<template>
    <div style="min-height: 90vh">
      <v-card style="display: flex; justify-content: flex-end">
        <v-icon @click="exportPDF">
          mdi-download
        </v-icon>
      </v-card>
      <div
        ref="invoiceBody"
        v-html="invoice.html"
      ></div>
      <VueHtml2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        :filename="`Faktura č. ${invoice.id}`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item">
          <div
            ref="invoiceBody"
            id="printInvoice"
            v-html="invoice.html"
          ></div>
          </section>
        </section>
      </VueHtml2pdf>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'InvoiceView',
  props: ['invoice'],
  components: {
    VueHtml2pdf
  },
  methods: {
    exportPDF () {
      this.$refs.html2Pdf.downloadPdf()
    }
  }
}
</script>

<style scoped>

</style>
